import { render, staticRenderFns } from "./NewScan.vue?vue&type=template&id=64de99a8&"
import script from "./NewScan.vue?vue&type=script&lang=js&"
export * from "./NewScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports